module.exports = __webpack_public_path__ + "img/eclub-logo-3-white.b6467a05.png";